import Request from '../Request';
import EndPoints, { applyPathVariables } from '../EndPoints';
import Methods from '../Methods';
import Session from "../../services/Session";
/**
 *
 * @param data
 * @return {Promise<any>|Promise}
 */
export default (function (data) {
    if (data === void 0) { data = null; }
    var url = applyPathVariables(EndPoints.LIST_ORGANISATION_DEVICES, { organisationId: Session.user.organisation.id });
    var request = new Request({ method: Methods.GET, url: url, withCredentials: true, data: data });
    return request.execute();
});
